import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export interface AtlantikNetworxxCredentialsDTO extends z.infer<typeof AtlantikNetworxxCredentialsDTORuntype> {}
export const AtlantikNetworxxCredentialsDTORuntype = z.object({
    client_id: z.string(),
    api_key: z.string(),
});

export interface AtlantikNetworxxCredentialsInputDTO extends z.infer<
    typeof AtlantikNetworxxCredentialsInputDTORuntype
> {}
export const AtlantikNetworxxCredentialsInputDTORuntype = z.object({
    client_id: z.string().optional(),
    api_key: z.string().optional(),
});

export interface AtlantikNetworxxResponseBodyDTO extends z.infer<typeof AtlantikNetworxxResponseBodyDTORuntype> {}
export const AtlantikNetworxxResponseBodyDTORuntype = z.object({
    data: AtlantikNetworxxCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
